module.exports = __webpack_public_path__ + "static/f12-171baa3782a41d5849e2d143ad46ee61.jpeg";